module.exports = __webpack_public_path__ + "static/media/logo-prism.dcaea431.ico";